// import { urls } from './Config.js';
import checkAJB from './checkAlipayJSBridge.js'
let CommonFunc = {
  // getUrlConfig(type, url) {
  //   return urls[type][url];
  // },
  getSessionId(callback) {
    // 获取native dangSessionID
    checkAJB.ready(() => {
      AlipayJSBridge.call('getSessionID', {}, result => {
        if (!result || result == '') {
          AlipayJSBridge.call('userLogin')
        } else {
          localStorage.setItem('dangSessionID', JSON.stringify(result))
          callback && callback()
        }
      })
    })
  },
  getSessionInfo() {
    return new Promise(resolve => {
      checkAJB.ready(() => {
        AlipayJSBridge.call('getSessionInfo', {}, result => {
          if (!result || result == '') {
            AlipayJSBridge.call('userLogin')
          } else {
            resolve(result)
          }
        })
      })
    })
  },
  // 获取请求头部信息
  getDangHeaders(callback) {
    return new Promise((resolve, reject) => {
      checkAJB.ready(() => {
        AlipayJSBridge.call('getDangHeaders', {}, result => {
          resolve(result)
          callback && callback()
        })
      })
    })
  },
  // 截取形如'CN=金鑫/OU=应用开发九部/OU=软件开发中心/OU=总行机关/O=ABC'的数据(常用联系人用到)
  splitStr(a) {
    let str = ''
    let arr = a.split('/')
    if (arr.length > 1) {
      arr.forEach(item => {
        str += '/' + item.split('=')[1]
      })
      return str
    } else {
      str = '/' + a
      return str
    }
  }
}
export function judgeClientType() {
  var userAgentInfo = navigator.userAgent
  var Agents = [
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod'
  ]
  var flag = true
  let clientType = ''
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  if (flag) {
    clientType = 'pc'
  } else {
    var u = navigator.userAgent
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // g
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    if (isAndroid) {
      // 这个是安卓操作系统
      clientType = 'android'
    }
    if (isIOS) {
      // 这个是ios操作系统
      clientType = 'ios'
    }
    if (u.indexOf('iPad') > -1) {
      clientType = 'ipad'
    }
  }
  return clientType
}
export default CommonFunc
